module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      marginTop: _vm.$root.headerHeight + 'px',
      marginBottom: _vm.$root.footerHeight + 'px'
    }),
    attrs: {
      "id": "app"
    }
  }, [_c(_vm.headerComponentName, {
    tag: "component",
    on: {
      "logout": _vm.logout
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content pb-5"
  }, [_c('router-view', {
    on: {
      "InitloggedIn": _vm.InitloggedIn
    }
  })], 1), _vm._v(" "), _c(_vm.footerComponentName, {
    ref: "footer",
    tag: "component",
    on: {
      "logout": _vm.logout
    }
  }), _vm._v(" "), _c('can-not-operate-within-demo-alert')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-32ef3187!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Wrap.vue
// module id = 691
// module chunks = 0